import { ApiService } from '@b2b/common/services/api/types';
import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { AccountAdministrationControllerModule } from './controllers/AccountAdministrationController';

export const AccountAdministrationView = angular
  .module('acme.view.application.account.administration', [
    uiRouter,
    'ui.bootstrap',
    AccountAdministrationControllerModule,
    'acme.common.controller.batchClient',
    'acme.common.directive.switcher',
    'acme.common.directive.integer',
    'acme.common.directive.numeric',
    'acme.common.service.api',
    'acme.common.service.helpers',
    'acme.common.directive.ccValidationSettings',
  ])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.account.administration',
      url: '/administration',
      views: {
        'subview-main': {
          controller: 'AccountAdministrationController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/account/administration/administration.tpl.html',
        },
      },
      data: {
        pageTitle: 'Administration',
        permissions: ['TENANT_ADMINISTRATION_VIEW'],
      },
      resolve: {
        ConfigData: [
          'ApiService',
          function (ApiService: ApiService) {
            return ApiService.administration.detail();
          },
        ],
        EmailTemplatesData: [
          'ApiService',
          function (ApiService: ApiService) {
            return ApiService.administration.emailTemplates.list();
          },
        ],
      },
    });
  }).name;
